module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm._handleClose),
      expression: "_handleClose"
    }],
    class: _vm.classes
  }, [_c('div', {
    ref: "reference",
    class: _vm.selectionClass,
    on: {
      "click": _vm.$_toggleMenu,
      "mouseenter": _vm.onSelfMouseenter,
      "mouseleave": _vm.onSelfMouseleave
    }
  }, [_vm._t("input", [(_vm.multiple && !_vm.collapseTags) ? _c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.selectedMultiple), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "list-inline-item"
    }, [_c('span', {
      staticClass: "tag tag--text"
    }, [_c('span', {
      staticClass: "tag__title"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('i', {
      staticClass: "aid aid-close tag__clear",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onClearTagClick(index)
        }
      }
    })])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.multiple && _vm.collapseTags && _vm.selectedMultiple.length) ? _c('ul', {
    staticClass: "list-inline"
  }, [(_vm.selectedMultiple[0]) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('span', {
    staticClass: "tag tag--text"
  }, [_c('span', {
    staticClass: "tag__title"
  }, [_vm._v(_vm._s(_vm.selectedMultiple[0].label))]), _vm._v(" "), _c('i', {
    staticClass: "aid aid-close tag__clear",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onClearTagClick(0)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.selectedMultiple.length > 1) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('span', {
    staticClass: "tag tag--text"
  }, [_c('span', {
    staticClass: "tag__title"
  }, [_vm._v("+" + _vm._s(_vm.selectedMultiple.length - 1))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlaceholder && !_vm.filterable),
      expression: "showPlaceholder && !filterable"
    }],
    class: [_vm.prefixSelfClass + '__placeholder']
  }, [_vm._v(_vm._s(_vm.localePlaceholder))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPlaceholder && !_vm.multiple && !_vm.filterable),
      expression: "!showPlaceholder && !multiple && !filterable"
    }],
    class: [_vm.prefixSelfClass + '__selected-value']
  }, [_vm._v(_vm._s(_vm.selectedSingle))]), _vm._v(" "), (_vm.filterable) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "input",
    class: [_vm.prefixSelfClass + '__input'],
    attrs: {
      "placeholder": _vm.showPlaceholder ? _vm.localePlaceholder : '',
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keydown": _vm.onInputKeydown,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        return _vm.onInputDelete($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: [_vm.prefixSelfClass + '__selection-icon']
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCloseIcon),
      expression: "showCloseIcon"
    }],
    class: (_vm.classMain + " " + _vm.prefixIconClass + "close-circle"),
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clearSingleSelect($event)
      }
    }
  }), _vm._v(" "), (!_vm.remote) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showArrow),
      expression: "showArrow"
    }],
    class: (_vm.classMain + " " + _vm.prefixIconClass + "chevron-down"),
    attrs: {
      "data-ani-icon": ""
    }
  }) : _vm._e()])])], 2), _vm._v(" "), _c('t-pop-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropShow),
      expression: "dropShow"
    }],
    ref: "drop",
    attrs: {
      "placement": _vm.placement,
      "style-class": _vm.prefixSelfClass + '__menu'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notFoundShow),
      expression: "notFoundShow"
    }],
    class: [_vm.prefixSelfClass + '__tips', 'cursor-text']
  }, [_vm._v(_vm._s(_vm.localeNotFoundText))]), _vm._v(" "), [_c('ul', {
    class: [_vm.prefixSelfClass + '__options']
  }, [_vm._t("default"), _vm._v(" "), (_vm.loadMore && !_vm.loading && !_vm.query) ? _c('li', {
    class: _vm.prefixSelfClass + '__item',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onLoadMore($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.localeLoadMoreText))]) : _vm._e()], 2)], _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    class: [_vm.prefixSelfClass + '__tips', 'cursor-text']
  }, [_vm._v(_vm._s(_vm.localeLoadingText))])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-170bfcac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/select/select.vue
// module id = 348
// module chunks = 0